module.exports = __webpack_public_path__ + "media/images/vp/samples/15-b63e263cb8a202762621e3089a84daae.jpg";